import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import { VoyagePartComponent } from 'src/app/transportation/vessels/voyage/voyage-part-component';
import { MessageLevel, PgMessagesService } from 'src/app/shared/services/pg-messages.service';
import { KeycloakService } from 'src/app/authentication/keycloak.service';
import moment from 'moment-timezone';
import { DateTimeHelpers } from '../../../../shared/helpers/date-time.helpers';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Voyage, Comment } from 'src/app/generated/services/transportation/voyages/voyage';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { MaterialPdfViewerComponent } from 'src/app/shared/components/material-pdf-viewer/material-pdf-viewer.component';
import { DocumentReference } from 'src/app/documents/documents.service';
import { VoyageServiceSpa } from 'src/app/generated/services/transportation/voyages/voyageSpa';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialDateRangeComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MaterialChunkFileUploadComponent,
    MaterialPdfViewerComponent,
    MaterialPgButtonComponent
  ]
})
export class CommentComponent implements OnInit, VoyagePartComponent {
  @Output() changed: EventEmitter<Voyage> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();

  key = 'Comment';
  _uploadedFileId!: string;
  _newUploadedFileId!: string;
  _selectedVoyage!: Voyage;
  _selectedDate!: DateRange;
  expectedVersion?: number;
  doc?: DocumentReference;
  comment: Comment;

  @Input() set fileId(value: string) {
    this._uploadedFileId = value;
  }
  @Input() set data(value: any) {
    this._selectedVoyage = value as Voyage;
  }
  @Input() set updatedFileId(value: string) {
    this._newUploadedFileId = value;
  }

  constructor(private _pgMessagesService: PgMessagesService,
              private _keycloakService: KeycloakService,
              private _voyagesService: VoyageServiceSpa,
              private _router: Router,
              private _activatedRoute: ActivatedRoute
  ) {
    this.comment = Comment.create();
  }

  ngOnInit() {
    this._activatedRoute.paramMap.subscribe(async p => {
      this._activatedRoute.queryParams.subscribe(p => {
        this._uploadedFileId = p['fileId'];
      });

      const result = await this._voyagesService.getVoyageById({
        id: p.get('id') || ''
      });

      this._selectedVoyage = result.data || Voyage.create();
      this.expectedVersion = result.version;

      this._selectedVoyage.comments.find(
        comment => comment.fileId === this._uploadedFileId
      );

      this._pgMessagesService.publishMessage({
        message: 'Navigated to comments component',
        level: MessageLevel.Debug,
        topic: 'Voyages'
      });

    });
  }

  saveComment() {
    this.comment.fileId = this._uploadedFileId;
    this.comment.author = this._keycloakService.getUser().username;
    this.comment.authorCommentTimestamp = new Date().getTime();
    this.comment.authorTimezone = moment.tz.guess();
    this.comment.incidentTimestamp = this._selectedDate.startDate.getTime();
    if (this._newUploadedFileId) {
      this.comment.fileId = this._newUploadedFileId;
    }

    if (this._selectedVoyage.comments) {
      this._selectedVoyage.comments.push(this.comment);
    } else {
      this._selectedVoyage.comments = [this.comment];
    }

    this.updateVoyage(this._selectedVoyage);
  }
  updateVoyage(voyage: Voyage) {
    this._voyagesService.updateVoyage({data: voyage, expectedVersion: this.expectedVersion || 0}).then(() => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        message: `Updated voyage ${voyage.shipVoyageNo} for ${voyage.vesselName}`,
        topic: 'Voyage'
      });
      this._router.navigate(['vessels/voyage', voyage.id], {
        queryParams: {
          t: new Date().getTime()
        }
      }).then();
    });
  }
  uploadDocument(docReference: DocumentReference) {
    this.comment.fileId = docReference.id;
  }
  deleteComment() {
    if (confirm(`Are you sure to delete comment on ${DateTimeHelpers.formatLocalDate(this.comment.authorCommentTimestamp)}`)) {
      const i = this._selectedVoyage.comments.findIndex(c => c.fileId === this.comment.fileId);
      this._selectedVoyage.comments.splice(i, 1);
      this.changed.emit(this._selectedVoyage);
    }
  }
  backToVoyage(){
    this._router.navigate(['/vessels/voyage/', this._selectedVoyage?.id,]);
  }
}
